<div class='finance-cost-tab-2-part'>
	This is finance-cost tab 2
</div>